export const deviationPopUp = {
    data() {
        return {}
    },
    methods: {
        showDeviationSwal(deviations) {
            let html = '';
            html += '<div class="deviation-container">';
            deviations.forEach(deviation => {
                console.log("deviation", deviation)
                html += ` <div class="deviation-table">`
                html += `<div><b class="deviation-label">${this.$t('shopfloor.cargoOrder.showDeviations.productNumber')}:</b></div><div>${deviation.locationAdditional}</div>`
                if (deviation.packingListNumber) {
                    html += `<div><b class="deviation-label">${this.$t('shopfloor.cargoOrder.showDeviations.packingListNumber')}:</b></div><div>${deviation.packingListNumber }</div>`
                }
                html += `<div><b class="deviation-label">${this.$t('shopfloor.cargoOrder.showDeviations.type')}:</b></div><div>${this.$t('deviations.deviations.' + deviation.type)}</div>`
                if (deviation.userName) {
                    html += `<div><b class="deviation-label">${this.$t('shopfloor.cargoOrder.showDeviations.createdBy')}:</b></div><div>${deviation.userName }</div>`
                }
                html += `</div>`
            });
            html += '</div>';
            this.$swal({
                title: this.$t('shopfloor.cargoOrder.showDeviations.title'),
                html: html,
                showCancelButton: true,
                showConfirmButton: false,
                cancelButtonText: this.$root.$t('ui.close'),
            });
        }
    }
}